// Calendar-day helpers. The diary is keyed by the person's local day, so
// everything here works on YYYY-MM-DD strings in local time — never UTC,
// which would file a late dinner under tomorrow.

export function toIsoDate(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function today(): string {
  return toIsoDate(new Date())
}

/** Local midnight of an ISO day. */
export function fromIsoDate(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y ?? 1970, (m ?? 1) - 1, d ?? 1)
}

export function addDays(iso: string, days: number): string {
  const date = fromIsoDate(iso)
  date.setDate(date.getDate() + days)
  return toIsoDate(date)
}

/** Whole days from `from` to `to` (negative when `to` is earlier). */
export function daysBetween(from: string, to: string): number {
  return Math.round((fromIsoDate(to).getTime() - fromIsoDate(from).getTime()) / 86_400_000)
}

/** The seven days ending on `end`, oldest first. */
export function weekEnding(end: string): string[] {
  return Array.from({ length: 7 }, (_, i) => addDays(end, i - 6))
}
